<template>
  <div class="sensorsMain-actions">
    <div class="sensorsMain-actions-buttons">
      <Button
          v-if="dataLineChart"
          class="download-pdf-button"
          variant="bordered"
          :title="$t('downloadTempPDF')"
          @click="generatePDF"
      />
      <Button
          v-if="dataLineChart && !isGroupView && selectedSensorsData?.[0]"
          class="downloadStamps-button"
          variant="bordered"
          :title="$t('downloadCheckStamps')"
          @click="downloadSensorCheckStamps(selectedSensorsData[0])"
      />
      <Button
          v-if="isGroupView && pharmacy"
          class="downloadAllStamps-button"
          variant="bordered"
          :title="$t('downloadAllCheckStamps')"
          @click="downloadAllCheckStamps"
      />
      <div class="sensorsMain-actions-stamp">
        <p v-if="normalizedStamp && !isGroupView">
          {{ $t('lastCheckedBy') }} {{ normalizedStamp.userName }} {{ formatTimestamp(normalizedStamp.timestamp) }}
        </p>
        <p v-if="allSensorsCheckInfo">
          {{ allSensorsCheckInfo.text }}
        </p>
      </div>
    </div>
  </div>
  <div v-if="!isGroupView" class="sensorsMain">
    <div
        v-for="el in selectedSensorsData"
        :key="el.id"
        class="sensorsMain-container"
    >
      <div class="sensorsMain-container-general">
        <div class="sensorsMain-left-column">
          <div class="sensorsMain-sensor">
            <div
                v-for="(item, index) in infoAboutSersor"
                :key="index"
                class="sensorsMain-sensor-info"
            >
              <p v-if="el[item.value]" class="title">{{ item.label }}</p>
              <span v-if="el[item.value]" class="value">
                {{ el[item.value] }}
              </span>
            </div>
            <div class="sensorsMain-sensor-info">
              <p class="title">{{ $t('lastTemperature') || 'Last Temp' }}</p>
              <span class="value">{{ getLastTempIndividual(el.sn) }}</span>
            </div>
            <div class="sensorsMain-sensor-info">
              <p class="title">{{ $t('sensorType') }}</p>
              <span class="value">{{ $t(el.type || 'individual') }}</span>
            </div>
            <div v-if="el.color" class="sensorsMain-sensor-info">
              <p class="title">{{ $t('colorLabel') }}</p>
              <span class="value sensorsMain-sensor-color">
                <span
                    class="sensorsMain-sensor-color__swatch"
                    :style="{ backgroundColor: el.color }"
                />
                {{ el.color }}
              </span>
            </div>
          </div>

          <div class="sensorsMain-buttons">
            <Button
                class="editSensor-button"
                variant="filled"
                :title="$t('editSensor')"
                @click="initEditSensor(el.id)"
            />
<!--            <Button-->
<!--                class="comment-button"-->
<!--                variant="filled"-->
<!--                :title="$t('comment')"-->
<!--                @click="initComment(el.id)"-->
<!--            />-->
          </div>
        </div>

        <div
            v-if="chartDataById(el.sn)?.labels?.length && isDateCorrect"
            class="sensorsMain-diagram"
        >
          <LineChart
              :id="'lineChart_' + el.sn"
              :key="lineChartKey"
              :data-line-chart="chartDataById(el.sn)"
              :options-line-chart="chartOptionsWithLegend"
              :style="styleLineChart"
          />
        </div>
      </div>

      <div class="sensorsMain-container-alarmsTable">
        <div class="sensorsMain-container-alarmsTable__title">
          <Button
              v-if="tableDataById(el.id)?.length && isDateCorrect"
              class="downloadAlarms-button"
              variant="bordered"
              :title="$t('downloadAlarms') || 'Download alarms'"
              @click="downloadAlarmsPdf(tableDataById(el.id), columnsById, el.name || el.sn)"
          />
          <p>{{ $t('deviationsInTimeFrame') }}</p>
        </div>

        <div v-if="tableDataById(el.id)?.length && isDateCorrect">
          <Table
            :data="tableDataById(el.id)"
            :columns="columnsById"
            @comment-sensor-alarm="openCommentModal"
            @comment-sensor-alarm-bulk="openBulkCommentModal"
          />
        </div>

        <div v-else class="no-alarms-message">
          <p>{{ $t('noAlarms') || 'No alarms found for this period' }}</p>
        </div>
      </div>
    </div>
  </div>

  <div
      v-if="isGroupView && isDateCorrect"
      class="sensorsMain"
  >
    <div class="sensorsMain-container-general">
      <div class="sensorsMain-left-column">
        <div class="sensorsMain-sensor">
          <div
              v-for="(item, index) in allSensorsLastTemps"
              :key="index"
              class="sensorsMain-sensor-info"
          >
            <p class="title">{{ item.id }}</p>
            <span class="value">{{ item.temp }}</span>
          </div>
          <div v-if="!allSensorsLastTemps.length" class="sensorsMain-sensor-info">
            <p class="title">{{ $t('loading') }}...</p>
          </div>
        </div>
      </div>

      <div class="sensorsMain-diagram">
        <LineChart
            :id="'lineChart'"
            :key="lineChartKey"
            :data-line-chart="processedAllChartData"
            :options-line-chart="chartOptionsWithLegend"
            :style="styleLineChart"
        />
      </div>
    </div>

    <div class="sensorsMain-container-alarmsTable">
      <div class="sensorsMain-container-alarmsTable__title">
        <Button
            v-if="transformedAlarmsSensor?.length && isDateCorrect"
            class="downloadAlarms-button"
            variant="bordered"
            :title="$t('downloadAlarms') || 'Download alarms'"
            @click="downloadAlarmsPdf(transformedAlarmsSensor, columns, selectedOption?.[0]?.label)"
        />
        <p>{{ $t('deviationsInTimeFrame') }}</p>
      </div>

      <div v-if="transformedAlarmsSensor?.length && isDateCorrect">
        <Table
          :data="transformedAlarmsSensor"
          :columns="columns"
          @comment-sensor-alarm="openCommentModal"
          @comment-sensor-alarm-bulk="openBulkCommentModal"
        />
      </div>

      <div v-else class="no-alarms-message">
        <p>{{ $t('noAlarms') || 'No alarms found for this period' }}</p>
      </div>
    </div>
  </div>

  <EditSensor
      :edit-sensor-data="editSensorData"
      :pharmacy-id="pharmacy?.id"
      :show-modal-edit-sensor="showModalEditSensor"
      @close-modal="showModalEditSensor = false"
  />
  <AddComment
      :edit-sensor-data="editSensorData"
      :pharmacy-id="pharmacy?.id"
      :show-modal-add-comment="showModalAddComment"
      @close-modal="showModalAddComment = false"
  />
  <AddSensorAlarmComment
      :show-modal="showSensorAlarmCommentModal"
      :active-alarm="activeAlarm"
      :loading="commentLoading"
      @close-modal="closeCommentModal"
      @save-comment="saveComment"
  />
</template>

<script lang="ts">
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';
import moment from 'moment';

import EditSensor from './EditSensor/EditSensor.vue';
import AddComment from './AddComment/AddComment.vue';
import AddSensorAlarmComment from '../AddSensorAlarmComment/AddSensorAlarmComment.vue';

import {
  infoAboutSersor,
  optionsLineChart,
  columnsById,
  columns
} from './configs';
import {
  AlarmSensor,
  DataSensor,
  Sensor,
  TemperatureSensorStamp
} from '@/store/modules/pharmacy/types';
import { getTemperatureSensorStampsRange } from '@/services/axiosService';
import { format } from 'date-fns';

@Options({
  name: 'SensorsMain',
  props: [
    'pharmacy',
    'lineChartKey',
    'dataLineChart',
    'alarmsSensor',
    'isDateCorrect',
    'selectedOption',
    'selectedSensorsData',
    'temperatureSensorStamp',
    'dateRange',
    'allSensorStamps',
    'groupView'
  ],
  components: {
    EditSensor,
    AddComment,
    AddSensorAlarmComment
  },
  emits: ['refreshAlarms'],
  computed: {
    lineChartComputed(): DataSensor[] {
      return this.dataLineChart || [];
    },
    // The combined (grouped) view shows a single merged chart + alarms table.
    // It is used for the "all" option and whenever the parent renders a sensor
    // group (room / fridge) via the groupView flag.
    isGroupView(): boolean {
      return !!this.groupView || this.selectedOption?.[0]?.value === 'all';
    },
    normalizedStamp(): TemperatureSensorStamp | null {
      const raw = this.temperatureSensorStamp;
      if (!raw) return null;
      if (Array.isArray(raw)) return raw[raw.length - 1] ?? null;
      return raw;
    },
    // Enables the legend on the chart
    chartOptionsWithLegend() {
      return {
        ...this.optionsLineChart,
        plugins: {
          ...this.optionsLineChart?.plugins,
          legend: {
            display: true,
            position: 'top',
            align: 'end',
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              // This filter hides the Min/Max lines from the legend
              filter: (item: any) => {
                const label = item.text ? item.text.toUpperCase() : '';
                return !label.includes('MAX') && !label.includes('MIN');
              },
              boxHeight: 4,
              boxWidth: 4
            }
          }
        }
      };
    },
    // Extracts the Last Temperatures for the "All" view table
    allSensorsLastTemps() {
      if (!this.isGroupView || !this.dataLineChart?.datasets) {
        return [];
      }

      return this.dataLineChart.datasets
        .filter((ds: any) => {
          // Exclude the Max/Min threshold (dashed) lines
          const label = (ds.label || '').toUpperCase();
          return !label.includes('MAX') && !label.includes('MIN');
        })
        .map((ds: any) => {
          const dataArr = ds.data || [];
          let lastVal: number | null = null;
          for (let i = dataArr.length - 1; i >= 0; i--) {
            const val = dataArr[i];
            if (val !== null && val !== undefined && !isNaN(val)) {
              lastVal = val;
              break;
            }
          }
          return {
            id: ds.label || 'Unknown ID',
            temp: lastVal !== null ? `${lastVal} °C` : '-'
          };
        });
    },
    // Ensures the labels for the "All" graph show the IDs in the legend
    processedAllChartData() {
      if (!this.dataLineChart) return null;

      // Clone so we don't mutate the prop directly
      const cloned = JSON.parse(JSON.stringify(this.dataLineChart));

      if (cloned.datasets) {
        cloned.datasets.forEach((ds: any, index: number) => {
          // Fallback to name/SN if needed
          ds.label = ds.label || `Sensor ${index + 1}`;
        });
      }
      return cloned;
    },
    transformedAlarmsSensor() {
      if (!this.alarmsSensor?.length) return [];

      return this.alarmsSensor.map((alarm: AlarmSensor) => {
        const alarmData = alarm as AlarmSensor & {
          sensorSn?: string;
          sn?: string;
          nameSensor?: string;
        };
        // The group-alarms endpoint identifies the sensor only through the
        // docId, whose prefix is the serial number (e.g. "282C02430DFA-2026-6").
        const snFromDoc = alarmData.docId
          ? alarmData.docId.split('-')[0]
          : undefined;
        const sensorSn = alarmData.sensorSn || alarmData.sn || snFromDoc;
        const sensor = this.pharmacy?.sensors?.find(
          (s: Sensor) => s.id === alarmData.id || s.sn === sensorSn
        );
        const sensorName =
          sensor?.name || alarmData.nameSensor || sensorSn || '';
        return {
          ...alarm,
          id: sensor?.id ?? alarmData.id,
          sensorSn: sensor?.sn ?? sensorSn,
          nameSensor: sensorName,
          sensorAlarmType: this.getSensorAlarmTypeText(alarmData.alarmType, sensorName)
        };
      });
    },
    allSensorsCheckInfo() {
      if (!this.isGroupView || !this.allSensorStamps?.length) return null;

      const valid = (this.allSensorStamps as Array<{ sensor: Sensor; stamp: TemperatureSensorStamp | null }>)
        .filter((s) => s.stamp);

      if (!valid.length) return null;

      const timestamps = valid.map((s) => s.stamp!.timestamp);
      const minTs = Math.min(...timestamps);
      const maxTs = Math.max(...timestamps);
      const allSame = maxTs - minTs <= 10000;
      const first = valid.find((s) => s.stamp!.timestamp === maxTs)!.stamp!;

      if (allSame) {
        const sameUser = valid.every((s) => s.stamp!.userName === first.userName);
        const userPart = sameUser ? ` ${first.userName}` : '';
        return {
          text: `${this.$t('allTemperaturesLastCheckedBy') || 'All temperatures last checked by'}${userPart} ${this.formatTimestamp(first.timestamp)}`,
          differ: false
        };
      }

      // Find the sensor whose latest stamp is oldest (checked least recently)
      const oldest = valid.reduce((min, s) =>
        s.stamp!.timestamp < min.stamp!.timestamp ? s : min
      );
      const oldestSameUser = valid.every((s) => s.stamp!.userName === oldest.stamp!.userName);
      const oldestUserPart = oldestSameUser ? ` ${oldest.stamp!.userName}` : '';
      return {
        text: `${this.$t('lastCheckedBy')}${oldestUserPart} ${this.formatTimestamp(oldest.stamp!.timestamp)} (${this.$t('timestampsDiffer') || 'timestamps differ'})`,
        differ: true
      };
    }
  },
  data() {
    return {
      editSensorData: null,
      infoAboutSersor: infoAboutSersor(this.$t),
      optionsLineChart: optionsLineChart,
      loading: false,
      checkedSensor: true,
      showModalEditSensor: false,
      showModalAddComment: false,
      showSensorAlarmCommentModal: false,
      commentLoading: false,
      activeAlarm: null,
      activeAlarms: [] as AlarmSensor[],
      columns: columns(this.$t),
      columnsById: columnsById(this.$t),
      height: 400,
      width: 900
    };
  },
  methods: {
    ...mapActions('pharmacy', ['sendSensorAlarmComment']),
    openCommentModal(alarm: AlarmSensor) {
      this.activeAlarm = alarm;
      this.activeAlarms = [alarm];
      this.showSensorAlarmCommentModal = true;
    },
    openBulkCommentModal(alarms: AlarmSensor[]) {
      if (!alarms?.length) return;
      this.activeAlarms = alarms;
      this.activeAlarm = alarms[0];
      this.showSensorAlarmCommentModal = true;
    },
    closeCommentModal() {
      this.showSensorAlarmCommentModal = false;
      this.activeAlarm = null;
      this.activeAlarms = [];
    },
    resolveSensorSn(alarm: AlarmSensor & { sensorSn?: string }) {
      return (
        alarm?.sensorSn ||
        this.pharmacy?.sensors?.find((s: Sensor) => s.id === alarm?.id)?.sn
      );
    },
    async saveComment(alarmInfo: string) {
      const alarms = (this.activeAlarms || []).filter(
        (alarm: AlarmSensor) =>
          this.resolveSensorSn(alarm) && alarm?.alarmStartTimestamp
      );

      if (!alarms.length) {
        this.closeCommentModal();
        return;
      }

      this.commentLoading = true;

      for (const alarm of alarms) {
        await this.sendSensorAlarmComment({
          data: {
            sensorSn: this.resolveSensorSn(alarm),
            alarmStartTimestamp: alarm.alarmStartTimestamp,
            alarmInfo
          }
        });
      }

      this.commentLoading = false;
      this.closeCommentModal();

      this.$emit('refreshAlarms');
    },
    chartDataById(sn: string) {
      if (!sn || !this.lineChartComputed?.length) return null;

      const found = this.lineChartComputed.find(
          (chart: DataSensor) => chart.id === sn
      );

      if (found && found.datasets?.[0]) {
        // Force the individual chart legend label to be the SN/ID
        found.datasets[0].label = sn;
      }

      return found || null;
    },
    // Extracts the Last Temperature for the Individual view
    getLastTempIndividual(sn: string) {
      const chart = this.chartDataById(sn);
      if (chart && chart.datasets?.[0]?.data?.length) {
        const dataArr = chart.datasets[0].data;
        for (let i = dataArr.length - 1; i >= 0; i--) {
          const val = dataArr[i];
          if (val !== null && val !== undefined && !isNaN(val)) {
            return `${val} °C`;
          }
        }
      }
      return '-';
    },
    getSensorAlarmTypeText(alarmType: string, sensorName: string) {
      if (alarmType === 'temp_high') {
        return this.$t('sensorAlarmTempHigh', { name: sensorName });
      }
      if (alarmType === 'temp_low') {
        return this.$t('sensorAlarmTempLow', { name: sensorName });
      }
      return alarmType || '';
    },
    tableDataById(id: string) {
      if (!id || !this.alarmsSensor?.length) return null;

      const sensorEntry = this.alarmsSensor.find(
          (alarm: AlarmSensor) => alarm.id === id
      );

      const sensor = this.pharmacy?.sensors?.find((s: Sensor) => s.id === id);
      const sensorName = sensor?.name || id;

      const sorted = sensorEntry?.alarmsSensor?.sort((a: AlarmSensor, b: AlarmSensor) => {
        return b.alarmStartTimestamp - a.alarmStartTimestamp;
      });

      return sorted?.map((alarm: AlarmSensor) => ({
        ...alarm,
        id,
        sensorSn: sensor?.sn,
        nameSensor: sensorName,
        sensorAlarmType: this.getSensorAlarmTypeText(alarm.alarmType, sensorName)
      })) || null;
    },
    dateTime(value: number) {
      if (value) {
        return moment(value).format('DD.MM.YYYY HH:mm');
      }
    },
    formatTimestamp(value: number) {
      if (!value) return '';
      return format(new Date(value), 'dd.MM.yyyy HH:mm');
    },
    // Replicates the alarm duration formatting used by the Table component so
    // the exported PDF matches the displayed cell exactly.
    getAlarmDuration(item: AlarmSensor) {
      const startDate =
        (item as AlarmSensor & { timestamp?: number }).alarmStartTimestamp ??
        (item as AlarmSensor & { timestamp?: number }).timestamp;
      const endDate = item.alarmEndTimestamp;

      if (!startDate || !endDate) return '';

      const diffTime = Math.abs(endDate - startDate);
      if (diffTime === 0) return '0';

      const diffH = Math.ceil(diffTime / (1000 * 60 * 60) - 1);
      const diffMin = Math.ceil(diffTime / (1000 * 60));

      if (diffH === 1) return `${diffH} ${this.$t('hour')}`;
      if (diffH === 0) return `${diffMin} ${this.$t('min')}`;
      return `${diffH} ${this.$t('hours')}`;
    },
    getAlarmAverageTemp(item: AlarmSensor) {
      let averageTemp: number | undefined;

      if (item.alarmMax && item.alarmMin) {
        averageTemp = (item.alarmMax + item.alarmMin) / 2;
      } else if (item.alarmMax && !item.alarmMin) {
        averageTemp = item.alarmMax / 2;
      } else if (!item.alarmMax && item.alarmMin) {
        averageTemp = item.alarmMin / 2;
      }

      if (!averageTemp) return '';
      return `${+averageTemp.toFixed(2)}`;
    },
    getAlarmCommentText(item: AlarmSensor) {
      const checks = (item as AlarmSensor & { check?: any[] }).check;
      if (!checks?.length) return '';

      // Sensor alarms keep every entry in `check` (unlike pickup-box alarms).
      return checks
        .map((comment) => {
          const checkTime = moment(comment.checkTime).format(
            'DD.MM.YYYY HH:mm'
          );
          const info = comment.alarmInfo || '';
          const commentText =
            info.length > 30 ? `${info.slice(0, 30)}...` : info;
          return `${commentText} (${comment.checkName} ${checkTime})`;
        })
        .join('; ');
    },
    // Formats a single alarm cell the same way the Table component renders it,
    // so the PDF is a faithful copy of the on-screen table.
    formatAlarmCell(row: AlarmSensor, columnValue: string) {
      switch (columnValue) {
        case 'alarmStartTimestamp':
        case 'alarmEndTimestamp':
          return this.dateTime((row as any)[columnValue]) || '';
        case 'duration':
          return `${this.getAlarmDuration(row)}`;
        case 'averageTemp':
          return this.getAlarmAverageTemp(row);
        case 'alarmComment':
          return this.getAlarmCommentText(row);
        default: {
          const value = (row as any)[columnValue];
          return value !== null && value !== undefined ? `${value}` : '';
        }
      }
    },
    downloadAlarmsPdf(
      rows: AlarmSensor[],
      cols: Array<{ value: string | number; label: string }>,
      label?: string
    ) {
      if (!rows?.length) return;

      const doc = new jsPDF('l', 'mm', 'a4');
      let currentY = 20;

      doc.setFontSize(18);
      doc.setTextColor(33, 33, 33);
      const heading = label
        ? `${this.$t('deviationsInTimeFrame')} — ${label}`
        : `${this.$t('deviationsInTimeFrame')}`;
      doc.text(heading, 14, currentY);
      currentY += 10;

      doc.setFontSize(11);
      doc.setTextColor(100, 100, 100);
      const startDate = this.dateRange?.startTime || 'N/A';
      const endDate = this.dateRange?.endTime || 'N/A';
      doc.text(
        `${this.$t('timeframe') || 'Timeframe'}: ${startDate} — ${endDate}`,
        14,
        currentY
      );
      currentY += 8;

      const head = [cols.map((c) => c.label)];
      const body = rows.map((row) =>
        cols.map((c) => this.formatAlarmCell(row, `${c.value}`))
      );

      autoTable(doc, {
        startY: currentY,
        head,
        body,
        theme: 'striped',
        headStyles: { fillColor: [71, 152, 127] },
        styles: { fontSize: 8, overflow: 'linebreak' },
        margin: { left: 14, right: 14 }
      });

      const namePart = label ? `_${label}` : '';
      doc.save(`Alarms${namePart}_${format(new Date(), 'yyyy-MM-dd')}.pdf`);
    },
    async downloadAllCheckStamps() {
      // Restrict to the currently selected group's sensors when available,
      // otherwise fall back to every sensor in the pharmacy.
      const groupSensors: Sensor[] = this.allSensorStamps?.length
        ? this.allSensorStamps.map(
            (s: { sensor: Sensor; stamp: TemperatureSensorStamp | null }) =>
              s.sensor
          )
        : this.pharmacy?.sensors || [];

      if (!groupSensors.length) return;

      const startTimeParts = this.dateRange?.startTime?.split('/');
      const endTimeParts = this.dateRange?.endTime?.split('/');
      if (!startTimeParts || !endTimeParts) return;

      const startTime = new Date(
        +startTimeParts[2],
        startTimeParts[1] - 1,
        +startTimeParts[0]
      ).valueOf();

      const today = format(new Date(), 'dd/MM/yyyy/HH/mm/ss').split('/');
      const endTime = new Date(
        +endTimeParts[2],
        endTimeParts[1] - 1,
        +endTimeParts[0],
        +today[3],
        +today[4],
        +today[5]
      ).valueOf();

      const rows: any[] = [];

      await Promise.all(
        groupSensors.map(async (sensor: Sensor) => {
          const stamps: TemperatureSensorStamp[] | undefined =
            await getTemperatureSensorStampsRange(sensor.sn, startTime, endTime);

          if (Array.isArray(stamps)) {
            stamps.forEach((stamp: TemperatureSensorStamp) => {
              rows.push({
                sensorName: sensor.name,
                timestamp: stamp.timestamp,
                userName: stamp.userName
              });
            });
          }
        })
      );

      rows.sort((a, b) => a.timestamp - b.timestamp);

      const doc = new jsPDF('p', 'mm', 'a4');
      let currentY = 20;

      doc.setFontSize(20);
      doc.setTextColor(33, 33, 33);
      doc.text('Check Stamps Report', 14, currentY);
      currentY += 10;

      doc.setFontSize(11);
      doc.setTextColor(100, 100, 100);
      doc.text(
        `Timeframe: ${this.dateRange.startTime} to ${this.dateRange.endTime}`,
        14,
        currentY
      );
      currentY += 10;

      const tableBody = rows.map((r) => [
        r.sensorName,
        format(new Date(r.timestamp), 'dd.MM.yyyy HH:mm'),
        r.userName
      ]);

      if (tableBody.length === 0) {
        doc.setFontSize(12);
        doc.setTextColor(100, 100, 100);
        doc.text('No check stamps found for this period.', 14, currentY);
      } else {
        autoTable(doc, {
          startY: currentY,
          head: [['Sensor', 'Check Time', 'Checked By']],
          body: tableBody,
          theme: 'striped',
          headStyles: { fillColor: [71, 152, 127] },
          margin: { left: 14, right: 14 }
        });
      }

      doc.save(`CheckStamps_${format(new Date(), 'yyyy-MM-dd')}.pdf`);
    },
    initEditSensor(id: string) {
      this.editSensorData = this.pharmacy?.sensors.find(
          (sensor: Sensor) => sensor.id === id
      );

      this.showModalEditSensor = true;
    },
    initComment(id: string) {
      this.editSensorData = this.pharmacy?.sensors.find(
          (sensor: Sensor) => sensor.id === id
      );

      this.showModalAddComment = true;
    },
    async downloadSensorCheckStamps(sensor: Sensor) {
      if (!sensor?.sn) return;

      const startTimeParts = this.dateRange?.startTime?.split('/');
      const endTimeParts = this.dateRange?.endTime?.split('/');
      if (!startTimeParts || !endTimeParts) return;

      const startTime = new Date(
        +startTimeParts[2],
        startTimeParts[1] - 1,
        +startTimeParts[0]
      ).valueOf();

      const today = format(new Date(), 'dd/MM/yyyy/HH/mm/ss').split('/');
      const endTime = new Date(
        +endTimeParts[2],
        endTimeParts[1] - 1,
        +endTimeParts[0],
        +today[3],
        +today[4],
        +today[5]
      ).valueOf();

      const stamps: TemperatureSensorStamp[] | undefined =
        await getTemperatureSensorStampsRange(sensor.sn, startTime, endTime);

      const doc = new jsPDF('p', 'mm', 'a4');
      let currentY = 20;

      doc.setFontSize(20);
      doc.setTextColor(33, 33, 33);
      doc.text(`Check Stamps — ${sensor.name}`, 14, currentY);
      currentY += 10;

      doc.setFontSize(11);
      doc.setTextColor(100, 100, 100);
      doc.text(
        `Timeframe: ${this.dateRange.startTime} to ${this.dateRange.endTime}`,
        14,
        currentY
      );
      currentY += 10;

      const rows = Array.isArray(stamps) ? stamps : [];
      rows.sort((a, b) => a.timestamp - b.timestamp);

      const tableBody = rows.map((s: TemperatureSensorStamp) => [
        sensor.name,
        format(new Date(s.timestamp), 'dd.MM.yyyy HH:mm'),
        s.userName
      ]);

      if (tableBody.length === 0) {
        doc.setFontSize(12);
        doc.setTextColor(100, 100, 100);
        doc.text('No check stamps found for this period.', 14, currentY);
      } else {
        autoTable(doc, {
          startY: currentY,
          head: [['Sensor', 'Check Time', 'Checked By']],
          body: tableBody,
          theme: 'striped',
          headStyles: { fillColor: [71, 152, 127] },
          margin: { left: 14, right: 14 }
        });
      }

      doc.save(`CheckStamps_${sensor.name}_${format(new Date(), 'yyyy-MM-dd')}.pdf`);
    },
    styleLineChart() {
      return {
        height: `${this.height}px`,
        width: `${this.width}px`,
        position: 'relative'
      };
    },
    async generatePDF() {
      this.loading = true;

      try {
        // 1. Initialize jsPDF (Portrait, Millimeters, A4 size)
        const doc = new jsPDF('p', 'mm', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        let currentY = 20; // Tracks vertical position on the page

        // 2. Add Heading & Description
        doc.setFontSize(22);
        doc.setTextColor(33, 33, 33);
        doc.text('Sensors Temperature Report', 14, currentY);
        currentY += 10;

        doc.setFontSize(11);
        doc.setTextColor(100, 100, 100);
        const description = 'This report contains the temperature graph, statistical data (minimum, maximum, average), and a summary of alarms for the selected sensors within the requested timeframe.';
        const splitDesc = doc.splitTextToSize(description, pageWidth - 28);
        doc.text(splitDesc, 14, currentY);
        currentY += (splitDesc.length * 5) + 5;

        // 3. Add Dates
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        const startDate = this.dateRange?.startTime || 'N/A';
        const endDate = this.dateRange?.endTime || 'N/A';
        doc.text(`Timeframe: ${startDate} to ${endDate}`, 14, currentY);
        currentY += 10;

        // 4. Add the Chart Image
        // Find the canvas element inside the LineChart component
        let chartElement = document.getElementById('lineChart');
        if (chartElement) {
          // If the ID is on a wrapper div, find the canvas inside
          if (chartElement.tagName !== 'CANVAS') {
            chartElement = chartElement.querySelector('canvas') || chartElement;
          }

          const canvas = chartElement as HTMLCanvasElement;
          const imgData = canvas.toDataURL('image/png', 1.0);

          // Calculate image dimensions to fit the PDF width
          const imgProps = doc.getImageProperties(imgData);
          const pdfImgWidth = pageWidth - 28; // 14mm margin on both sides
          const pdfImgHeight = (imgProps.height * pdfImgWidth) / imgProps.width;

          // Draw the image
          doc.addImage(imgData, 'PNG', 14, currentY, pdfImgWidth, pdfImgHeight);
          currentY += pdfImgHeight + 15;
        }

        // 5. Calculate Data for Min/Max/Avg Table
        const statsBody: any[] = [];

        if (this.dataLineChart && this.dataLineChart.datasets) {
          this.dataLineChart.datasets.forEach((ds: any) => {
            const label = (ds.label || '').toUpperCase();

            // Skip threshold lines if they exist in your chart
            if (!label.includes('MAX') && !label.includes('MIN')) {
              const data = ds.data.filter((val: any) => typeof val === 'number' && !isNaN(val));

              if (data.length > 0) {
                const min = Math.min(...data).toFixed(2);
                const max = Math.max(...data).toFixed(2);
                const sum = data.reduce((a: number, b: number) => a + b, 0);
                const avg = (sum / data.length).toFixed(2);

                statsBody.push([ds.label || ds.id, `${min} °C`, `${max} °C`, `${avg} °C`]);
              } else {
                statsBody.push([ds.label || ds.id, '-', '-', '-']);
              }
            }
          });
        }

        // Check if we need a new page for the tables
        if (currentY > doc.internal.pageSize.getHeight() - 40) {
          doc.addPage();
          currentY = 20;
        }

        // Draw Stats Table using AutoTable
        doc.setFontSize(14);
        doc.text('Temperature Statistics', 14, currentY);
        currentY += 5;

        autoTable(doc, {
          startY: currentY,
          head: [['Sensor ID', 'Min Temp', 'Max Temp', 'Average Temp']],
          body: statsBody,
          theme: 'striped',
          headStyles: { fillColor: [71, 152, 127] }, // A nice green/teal color
          margin: { left: 14, right: 14 }
        });

        // Move Y coordinate to below the newly generated table
        currentY = (doc as any).lastAutoTable.finalY + 15;

        // 6. Format Data for Alarms Table
        doc.setFontSize(14);
        doc.text('Alarms Summary', 14, currentY);
        currentY += 5;

        const alarmsBody: any[] = [];
        if (this.alarmsSensor && this.alarmsSensor.length > 0) {
          this.alarmsSensor.forEach((alarm: AlarmSensor) => {
            const time = this.dateTime(alarm.alarmStartTimestamp) || '-';
            const sensorId = alarm.id || 'Unknown';

            // Replace 'alarmMessage' with whatever key holds your deviation details
            const details = (alarm as any).alarmMessage || (alarm as any).status || 'Deviation detected';
            alarmsBody.push([sensorId, time, details]);
          });
        }

        if (alarmsBody.length > 0) {
          autoTable(doc, {
            startY: currentY,
            head: [['Sensor ID', 'Deviation Time', 'Details']],
            body: alarmsBody,
            theme: 'grid',
            headStyles: { fillColor: [226, 82, 63] }, // Red color for alarms
            margin: { left: 14, right: 14 }
          });
        } else {
          doc.setFontSize(11);
          doc.setTextColor(100, 100, 100);
          doc.text('No alarms found for this period.', 14, currentY);
        }

        // 7. Save the PDF
        const fileName = `Sensors_Report_${moment().format('YYYY-MM-DD')}.pdf`;
        doc.save(fileName);

      } catch (error) {
        console.error("Error generating PDF:", error);
      } finally {
        this.loading = false;
      }
    }
  }
})
export default class SensorsMain extends Vue {}
</script>

<style lang="scss" scoped>
.sensorsMain-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .sensorsMain-actions-buttons {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .sensorsMain-actions-stamp {
    font-size: 13px;
    color: $mid-grey;
  }
}

.sensorsMain {
  .sensorsMain-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 32px;
  }

  // Applied to both Individual and All views
  .sensorsMain-container-general {
    display: flex;
    align-items: flex-start; // Align top so button columns drop nicely
    justify-content: flex-start;

    // NEW WRAPPER FOR LEFT PANEL
    .sensorsMain-left-column {
      display: flex;
      flex-direction: column;
      width: 175px; // Matches old sensor max-width
      margin-right: 24px;
      margin-top: 30px;

      .sensorsMain-sensor {
        width: 100%;
        padding: 12px 24px; // Slightly reduced padding to fit temps safely
        border-radius: 8px;
        border: 1px solid $border;
        background-color: $light-grey;
        margin-bottom: 16px; // Space between box and buttons
        max-height: 400px;
        overflow-y: auto; // Allows scrolling in "All" view if there are many sensors

        .sensorsMain-sensor-info {
          margin-bottom: 24px;
          background-color: $light-grey;
          &:last-child {
            margin-bottom: 0;
          }
          .title {
            color: $label;
            font-size: $twelveSize;
            line-height: 14px;
            margin-bottom: 7px;
            background-color: $light-grey;
            word-break: break-all; // Prevents long IDs from breaking UI
          }
          .value {
            width: max-content;
            color: $mid-grey;
            font-size: $fourteenSize;
            background-color: $light-grey;
          }
          .sensorsMain-sensor-color {
            display: flex;
            align-items: center;
            gap: 8px;
            .sensorsMain-sensor-color__swatch {
              display: inline-block;
              width: 16px;
              height: 16px;
              border-radius: 4px;
              border: 1px solid $border;
              flex-shrink: 0;
            }
          }
        }
      }

      .sensorsMain-buttons {
        display: flex;
        flex-direction: column;
        width: 100%;

        .editSensor-button {
          margin-bottom: 12px;
          width: 100%;
        }
        .comment-button {
          width: 100%;
        }
      }
    }

    .sensorsMain-diagram {
      width: 900px;
      height: 400px;
      margin: 0 auto;
    }
  }

  .sensorsMain-container-alarmsTable {
    max-height: 450px;
    height: 100%;
    .sensorsMain-container-alarmsTable__title {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-top: 50px;
      margin-bottom: 24px;
      .downloadAlarms-button {
        width: max-content;
        height: 34px;
      }
      p {
        font-family: 'Ubuntu-Medium';
        font-size: $sixteenSize;
        line-height: $fourteenSize;
        font-weight: 500;
      }
    }
    .no-alarms-message {
      padding: 20px;
      background-color: $light-grey;
      border: 1px dashed $border;
      border-radius: 8px;
      text-align: center;
      margin-top: 10px;

      p {
        color: $mid-grey;
        font-size: $fourteenSize;
        margin: 0;
      }
    }
  }
}
</style>